/** PHASE 3A.6D — пользовательские подписи (только русский язык в UI). */

export function formatGroupTitle(params: {
  applicationNumber?: string | null;
  clientName?: string | null;
  index: number;
}): string {
  if (params.applicationNumber) {
    const client = params.clientName ? ` — ${params.clientName}` : '';
    return `Заявка №${params.applicationNumber}${client}`;
  }
  return `Группа маршрута ${params.index + 1}`;
}

export const ROUTE_UX = {
  topologySection: 'Структура маршрута',
  addGroup: 'Добавить группу маршрута',
  removeGroup: 'Удалить группу',
  loadingSection: 'Точки погрузки',
  unloadingSection: 'Точки выгрузки',
  addLoadingStop: 'Добавить точку погрузки',
  addUnloadingStop: 'Добавить точку выгрузки',
  selectApplication: 'Выберите заявку',
  warehouse: 'Склад',
  application: 'Заявка',
  consignee: 'Получатель',
  address: 'Адрес',
  contact: 'Контакт',
  phone: 'Телефон',
  date: 'Дата',
  inTransitWarning: 'Маршрут находится в исполнении',
  inTransitHint: 'Изменения затронут только будущие точки. Выполненные точки недоступны для редактирования.',
  cargoStepTitle: 'Шаг 4: Загрузка и распределение грузов',
  cargoGroupNav: 'Группа маршрута',
  cargoLoadingNav: 'Точка погрузки',
  cargoName: 'Наименование',
  cargoQty: 'Количество',
  cargoWeight: 'Вес, кг',
  cargoDest: 'Куда везём',
  cargoSelectHint: 'Отметьте грузы для загрузки на выбранной точке погрузки',
  lockedStopHint: 'Точка уже выполнена — изменения могут затронуть историю исполнения',
  completedStopBadge: 'Выполнено',
  currentStopBadge: 'В исполнении',
  itinerarySection: 'Маршрут (порядок исполнения)',
  itineraryHint:
    'Порядок точек задаёт последовательность исполнения. Выгрузка должна идти после своей погрузки.'
} as const;
